import { Component, Vue, Prop } from 'vue-property-decorator'
import { VTextField, VSelect } from 'vuetify/lib'
import VTreeSelect from '@/resources/components/shared/VTreeSelect.vue'
import VTreeSelectEnhanced from '@/resources/components/shared/VTreeSelectEnhanced.vue'
import VAddress from '@/resources/components/shared/VAddress.vue'
import VUploadId from '@/resources/components/shared/VUploadId.vue'
import VClientContact from '@/resources/components/shared/VClientContact.vue'

interface Properties {
    defaultValue?: string;
    field?: string
    label?: string
    items: Array<string>
    hint?: string
    persistentHint?: string
    clearable?: boolean
    name?: string
    box?: boolean
    slot?: string
    type?: string
    disabled?: boolean,
    readonly?: boolean,
    min: number,
    max: number,
    vModel: any,
    'secondary-schema'?: object,
    'menu-props'?: object,
    alternateKey: string,
    extra?: Properties
}

interface Attributes {
    label?: string,
    placeholder?: string,
    name?: string,
    hint?: string,
    'persistent-hint'?: string,
    'error-messages'?: object[],
    disabled?: boolean,
    readonly?: boolean,
    box?: boolean,
    type?: string,
    value?: any,
    min: number,
    max: number
}

@Component({
    components: {
        'v-text-field': VTextField,
        'v-select': VSelect,
        'v-tree-select': VTreeSelect,
        'v-tree-select-enhanced': VTreeSelectEnhanced,
        'v-address': VAddress,
        'v-upload-id': VUploadId,
        'v-client-contact': VClientContact
    }
})
export default class FieldGenerator extends Vue {

    @Prop(Object) schema!: Properties
    @Prop(Array) secondarySchema!: Array<object>
    @Prop(Object) menuProps!: object
    @Prop(Array) errorMessage!: Array<object>
    @Prop(Number) index!: number

    value: any = ''
    once: boolean = false
    updateheader: boolean = false

    render(createElement: any) {

        // if there is a defaultValue specified, set the model value and fire a change event once
        // (this is the render loop, so doing this more than once is a really bad idea)
        if(!this.once && this.schema.defaultValue) {
            this.value = this.schema.defaultValue

            let self = this
            // we'll delay this one a little bit, give the element a chance to render first
            setTimeout(() => {
              self.$emit('change', self.value)
            }, 200)
            this.once = true
        }

        // @ts-ignore
        // this makes changes get passed up to the panel header for specific fields only
        this.updateheader = this.schema.updateheader;

        // @ts-ignore
        let attributes : Attributes = {
            label: this.schema.label,
            placeholder: this.schema.label,
            name: this.schema.label,
            hint: this.schema.hint,
            'persistent-hint': this.schema.persistentHint,
            'error-messages': this.errorMessage,
            disabled: this.schema.disabled,
            readonly: this.schema.readonly,
            box: this.schema.box,
            type: this.schema.type,
            value: this.value
        }

        // @ts-ignore
        let properties : Properties = {
            vModel: this.value,
            items: this.schema.items,
            'secondary-schema': this.secondarySchema,
            'menu-props': this.menuProps,
            extra: this.schema
        }

        return createElement(
            'div',
            [
                createElement(this.schema.field, {
                    attrs: attributes,
                    props: properties,
                    on: {
                        change: (event: string) => {
                            this.$emit('change', event)
                            this.value = event

                            if(this.updateheader) {
                                let v = '';

                                // fish the select value out of the secondary schema
                                if(this.secondarySchema && this.secondarySchema.length > 0) {
                                    for(let i = 0; i < this.secondarySchema.length; i++) {
                                        let s = this.secondarySchema[i];
                                        // @ts-ignore
                                        if(s.code === event) {
                                            // @ts-ignore
                                            v = s.description
                                            break;
                                        }
                                    }
                                } else {
                                    v = this.value
                                }

                                // do something special if we've got items:
                                this.$emit('updateheader', {
                                    label: this.schema.label,
                                    value: v,
                                    index: this.index
                                })

                                // this ensures the dirty flags etc get set by validator
                                this.$emit('input', event)
                            }

                        },
                        extra: (event: any) => {
                            this.$emit('extra', event)
                        },
                        observationheader: (event: any) => {
                            let headerValue = '';
                            if( event.name ) {
                                headerValue = event.parent + ' - ' + event.name
                            }
                            this.$emit('updateheader', {
                                label: this.schema.label,
                                value: headerValue,
                                index: this.index
                            })
                        },
                        input: (event: any) => {
                            // some of the form elements (text fields/enhanced tree select) do not pass on the input event, so watching for it specifically here
                            // this ensures the dirty flags etc get set by validator
                            this.$emit('input', event)
                        }
                    }
                })
            ])
    }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-014a824b/FieldGenerator.tsx" });